import React from 'react';
import './style.css';
import Appointments from './components/appointments/index';
import Payments from './components/payments/index';

export default class PatientTabs extends React.Component {
    state = {
        tab: "appointments"
    }

    getActive = (tab) => {
        return tab == this.state.tab ? " is-active" : "";
    }

    changeTab = (tab) => {
        if(tab != this.state.tab)
            this.setState({tab: tab})
    }

    render() {
        return (
            <div className="PatientTabs">
                <div className="card">
                    <div className="card-header">
                        <h2 className="card-header-title">
                            Historiales
                        </h2>
                        <a className={`card-header-icon header-button${this.getActive("appointments")}`}
                            onClick={() => this.changeTab("appointments")}
                        >
                            Historial de citas
                        </a>
                        <a className={`card-header-icon header-button${this.getActive("payments")}`}
                            onClick={() => this.changeTab("payments")}
                        >
                            Historial de pagos
                        </a>
                    </div>
                    <div className="card-content">
                        {this.state.tab == "appointments" ?
                            <Appointments patient={this.props.patient} /> :
                            <Payments patient={this.props.patient} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/scenes/patient-tabs/index.js